import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: ":examRegId/:section/edit",
  exact: true,
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "edit-information" */ "./components"),
      import(
        /* webpackChunkName: "ibis-registration-details" */ "DPExamRegistration/modules/DPExamRegistrationModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "dpExamReg",
        reducer,
      });
      return component;
    })
  ),
});
